var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('topNav'),_c('sideMenuMobie'),_c('adsCouse'),_c('b-row',[_c('b-col',{attrs:{"lg":"2"}},[_c('sideMenu')],1),_c('b-col',{attrs:{"lg":"10"}},[_c('listCourses')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }